export default "__VITE_ASSET__WTwwCJe$RrPmcZuoUQi1sA__"